'use client'

import { useContext } from 'react'

import { CollapsibleAreaInOrderFormBody } from '@/features/order/order-form/components/widget/collapsible'
import { OrderFormCollapsibleContext } from '@/features/order/order-form/lib/order-form-collapsible-context'

// Renders Order Trigger / Exit Condition as the sheet's expanded right-column detail
// view. Consumes the same config/updateConfig as the left form's (hidden while
// expanded) CollapsibleAreaInOrderForm via OrderFormCollapsibleContext — this component
// must be mounted under that Provider and inside OrderFormProvider (see order-form-sheet.tsx).
export default function OrderFormDetailPanel() {
  const ctx = useContext(OrderFormCollapsibleContext)

  if (!ctx) return null

  return (
    <CollapsibleAreaInOrderFormBody
      config={ctx.config}
      updateConfig={ctx.updateConfig}
      layout="detail"
    />
  )
}
